import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import {
  isAdminSuperuser,
  loadMeasurement,
  syncAdminSuperuserState,
  trackPageView,
} from '../../services/measurement';

const AnalyticsProvider = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const { currentUser } = useAuth();
  const lastPage = useRef('');

  // Sync admin superuser state whenever currentUser changes
  useEffect(() => {
    syncAdminSuperuserState(currentUser);
  }, [currentUser]);

  // Load measurement (unless user is superuser)
  useEffect(() => {
    if (!isAdminSuperuser(currentUser, pathname)) {
      loadMeasurement(currentUser);
    }
  }, [currentUser, pathname]);

  // Track page views across all public and private pages, strictly excluding admin superusers
  useEffect(() => {
    if (isAdminSuperuser(currentUser, pathname)) {
      return;
    }

    if (pathname === lastPage.current) return;
    lastPage.current = pathname;

    trackPageView({
      pathname,
      user: currentUser,
      title: document.title,
    });
  }, [currentUser, pathname]);

  return children;
};

export default AnalyticsProvider;
